import { cn } from '@/lib/utils'

interface LogoProps {
  variant?: 'horizontal' | 'icon'
  theme?: 'light' | 'dark'
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

export function Logo({ variant = 'horizontal', theme = 'light', className, size = 'md' }: LogoProps) {
  const iconSizes = { sm: 24, md: 40, lg: 56 }
  const iconSize = iconSizes[size]
  const wordmarkColor = theme === 'dark' ? '#F8F4EC' : '#0A1628'
  const wordmarkSize = { sm: 'text-sm', md: 'text-xl', lg: 'text-2xl' }[size]

  const Icon = (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Echosome"
    >
      <path d="M 8 40 A 24 24 0 0 1 56 40" fill="none" stroke="var(--echo-mark)" strokeWidth="2" strokeLinecap="round" opacity="0.32"/>
      <path d="M 14 40 A 18 18 0 0 1 50 40" fill="none" stroke="var(--echo-mark)" strokeWidth="2" strokeLinecap="round" opacity="0.6"/>
      <path d="M 20 40 A 12 12 0 0 1 44 40" fill="none" stroke="var(--echo-mark)" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="32" cy="40" r="3.6" fill="var(--echo-mark)"/>
    </svg>
  )

  if (variant === 'icon') {
    return <div className={cn('inline-flex', className)}>{Icon}</div>
  }

  return (
    <div className={cn('inline-flex items-center gap-3', className)}>
      {Icon}
      <span
        className={cn('font-medium tracking-tight', wordmarkSize)}
        style={{ color: wordmarkColor, letterSpacing: '-0.02em', marginTop: '-2px' }}
      >
        echosome
      </span>
    </div>
  )
}
